// @ts-check
import {of} from 'rxjs';
import {map, switchMap, catchError} from 'rxjs/operators';
import {ofType} from 'redux-observable';

import fileDownload from 'js-file-download';

import Http from '../../http/http';
import AppSettings from '../../app.settings';

import EquipmentSearchService from '../../equipment/services/equipment-search.service';

import {HISTORY_SELECTED} from '../history/history.action';
import {FAVOURITE_SELECTED} from '../favourite/favourite.action';
import {COLUMN_VISIBLE_TOGGLED} from '../table-columns/table-columns.action';

import * as Search from './search.action';

import {adaptFacets} from './search.state';

import {LOAD as REDUX_STORAGE_LOAD} from 'redux-storage';

export const mapToSearchRequested = action$ => {
  const actionTypes = [HISTORY_SELECTED, FAVOURITE_SELECTED];

  return action$.pipe(
    ofType(...actionTypes),
    map(action => Search.initiated(action.payload.search))
  );
};

export const mapToUpdatePrerequisitesTOMakeNewSearch = (action$, store$) => {
  const actionTypes = [
    Search.QUERY_ADDED,
    Search.QUERY_REMOVED,
    Search.FACET_SELECTED,
    Search.FACET_DESELECTED,
    Search.TAG_FILTERS_UPDATED,
    Search.TAG_FILTER_ADDED,
    Search.TAG_FILTER_REMOVED,
    Search.FACET_DESELECTED_EXCLUSIVE,
    Search.FACET_SELECTED_EXCLUSIVE,
    Search.SEARCH_INITIATED,
    Search.ACCOUNT_ADDED,
    Search.ACCOUNT_REMOVED,
    Search.SEARCH_RESET,
    Search.SORT_UPDATED,
    Search.LAST_SEEN_UPDATED
  ];

  return action$.pipe(
    ofType(...actionTypes),
    map(() => {
      const {assets} = store$.value;
      const limit = assets.pageSize;
      const since = 0;
      return Search.updatePrerequisites({
        limit: limit,
        since: since,
        newSearch: true,
        resetSelectedAssets: true
      });
    })
  );
};

export const mapToUpdatePrerequisitesToRefreshSearch = (action$, store$) => {
  const actionTypes = [COLUMN_VISIBLE_TOGGLED, Search.SEARCH_REFRESH, REDUX_STORAGE_LOAD];

  return action$.pipe(
    ofType(...actionTypes),
    map(() => {
      const {assets} = store$.value;
      const limit = assets.currentPage * assets.pageSize;
      const since = 0;
      return Search.updatePrerequisites({
        limit: limit,
        since: since
      });
    })
  );
};

export const mapToSearchUpdated = action$ =>
  action$.pipe(
    ofType(Search.UPDATE_SEARCH_PREREQUISITES),
    map(() => Search.updated())
  );

export const mapToSearchBegin = action$ =>
  action$.pipe(
    ofType(Search.SEARCH_UPDATED),
    map(() => Search.requested())
  );

const buildFetchAssetsObject = store => {
  const {search} = store;
  const {sort, query, tagFilters, accounts, since, limit} = search;
  const options = {limit, since};
  const sortStringArray = [`${sort.name}:${sort.direction}`];
  const facets = adaptFacets(search);
  const accountsArray = accounts.filter(acc => acc._selected).map(acc => acc.id);
  let finalQuery = query || [];
  finalQuery = Array.isArray(query) ? query : [query];

  const assetQuery = EquipmentSearchService().buildAPIEquipmentFilterObject(
    finalQuery,
    options,
    null, // TODO: define default or determine if this is required
    null, // TODO: define default or determine if this is required
    facets,
    tagFilters,
    null, // TODO: define default or determine if this is required
    null, // TODO: define default or determine if this is required
    sortStringArray,
    accountsArray
  );

  return {
    columns: store.tableColumns.selected,
    filter: assetQuery
  };
};

export const searchBegin = (action$, store$) =>
  action$.pipe(
    ofType(Search.SEARCH_REQUESTED),
    switchMap(() =>
      Http.post(`${AppSettings.BaseTugApiUrl}/assets`, buildFetchAssetsObject(store$.value)).pipe(
        map(data =>
          Search.searchSuccess({
            query: store$.value.search,
            data: data
          })
        ),
        catchError(error =>
          of(Search.searchFailure((error || {}).message || 'Whoops! Something went wrong. Please try again.'))
        )
      )
    )
  );

export const exportSearch = (action$, store$) =>
  action$.pipe(
    ofType(Search.SEARCH_EXPORT),
    switchMap(() =>
      Http.post(`${AppSettings.BaseTugApiUrl}/assets/export`, buildFetchAssetsObject(store$.value)).pipe(
        map(response => {
          fileDownload(response, 'search_export.csv');
          return Search.searchExportSuccess();
        }),
        catchError(() => of(Search.searchExportFailure()))
      )
    )
  );
